import AppConstants from '../config/app.constants';

let ContractTypeService = function ($http, $q){
    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/contract-type`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data;
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/contract-type/create`, { data })
            .then((res) => {
                return res.data;
            })
    };

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/contract-type/${id}/update`, data)
            .then((res) => {
                return res.data;
            })
    };

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/contract-type/${id}`)
            .then((res) => {
                return res.data;
            })
    }


    return {
        all,
        create,
        update,
        get
    };

}

ContractTypeService.$inject = ['$http', '$q'];

export default ContractTypeService;


// WEBPACK FOOTER //
// ./client/app/services/contract-type.service.js